import { branch, compose, renderComponent, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import CheckShopPermissionPasscodeModal from './CheckShopPermissionPasscodeModal';
import { requirePasscodeEnabled } from '../../../main/timeTracker/selectors';
import { getActiveShopUserPermissionPasscode } from '../../../auth/selectors';

export default compose(
  connect(state => ({
    isPermissionPasscodeRequired: requirePasscodeEnabled(state),
    passcode: getActiveShopUserPermissionPasscode(state),
  })),
  withState('passcodeVerified', 'setPasscodeVerified', false),
  withHandlers({
    checkPasscode: props => (passcode) => {
      if (passcode === props.passcode) {
        props.setPasscodeVerified(true);

        return true;
      }

      return false;
    },
  }),
  branch(
    props => props.isPermissionPasscodeRequired && !props.passcodeVerified,
    renderComponent(CheckShopPermissionPasscodeModal)
  )
);
